export default __webpack_public_path__ + "static/media/date.52edf84f.svg";